export const isStickyInViewMode = (tableElement: HTMLElement | null): boolean => {
	return Boolean(tableElement?.getAttribute('mode') === 'stick');
};

export const isStickyInEditMode = (tableElement: HTMLElement | null): boolean => {
	return Boolean(tableElement?.classList.contains('pm-table-row-native-sticky-active'));
};

export const getIsSticky = (
	tableElement: HTMLElement | null,
	isEditor: boolean | undefined,
): boolean => (isEditor ? isStickyInEditMode(tableElement) : isStickyInViewMode(tableElement));
